import React from "react";
import { SimpleInfoEntry } from "../SimpleInfoEntry";
export default function SimpleListEntry(param) {
    var entries = param.entries, className = param.className;
    return /*#__PURE__*/ React.createElement("div", {
        className: className
    }, entries.map(function(entry, index) {
        return /*#__PURE__*/ React.createElement(React.Fragment, {
            key: "entry-".concat(entry.title)
        }, index > 0 && /*#__PURE__*/ React.createElement("div", {
            role: "presentation",
            className: "border-b border-b-fg-base/20 my-7 md:my-10"
        }), /*#__PURE__*/ React.createElement(SimpleInfoEntry, {
            title: entry.title,
            description: entry.description,
            action: entry.action
        }));
    }));
}

//# sourceMappingURL=SimpleEntryList.js.map